import React, { Component } from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from 'reactstrap';
import ThrobbleHelper from '../helpers/ThrobbleHelper';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div className='position-relative'>
        <NavMenu />
        <Container>
          <Outlet />
        </Container>
        <ThrobbleHelper />
      </div>
    );
  }
}
